import { translateFn } from '../../../../../../../utils/translator.helper';
import { SelectOption } from '../../../../../../../ui/gzDropdown/types';


export enum PhasrOptions {
  OFF = 0,
  DIRECT_CONTROL = 1,
  AUTOPILOT = 2,
}

export function getPhasrOptions(): Array<SelectOption> {
  return [
    {
      title: translateFn('Off'),
      value: PhasrOptions.OFF,
    },
    {
      title: translateFn('Autopilot'),
      value: PhasrOptions.AUTOPILOT,
    },
    {
      title: translateFn('Direct control'),
      value: PhasrOptions.DIRECT_CONTROL,
    },
  ];
}
